import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ConfirmPage() {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || '');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { confirmEmail } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await confirmEmail(email, code);
      navigate('/login', { state: { message: 'Email verified! You can now sign in.' } });
    } catch (err) {
      setError(err || 'Invalid verification code');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">📧</div>
          <div className="auth-title">Check Your Email</div>
          <div className="auth-subtitle">We sent a verification code to your email</div>
        </div>
        {error && <div className="error-msg" style={{marginBottom:16}}>{error}</div>}
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input className="form-input" type="email" value={email}
              onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label">Verification Code</label>
            <input className="form-input" type="text" value={code}
              onChange={e => setCode(e.target.value)} placeholder="6-digit code" required
              style={{fontFamily:'monospace', letterSpacing:'0.15em', fontSize:18}} />
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? 'Verifying…' : 'Verify Email'}
          </button>
        </form>
        <div className="auth-footer"><Link to="/login">← Back to sign in</Link></div>
      </div>
    </div>
  );
}

export default ConfirmPage;
